import React, { useState } from 'react';
import {
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CRow,
} from '@coreui/react';
import { Redirect, useParams } from 'react-router-dom';
import AuthUtils from '../../shared/utils/auth-utils';
import SetupNextSteps from '../components/SetupNextSteps';
import SetupForm from '../components/SetupForm';

const SetupPage = () => {
  const { token } = useParams<{token: string}>();
  const [setupComplete, setSetupComplete] = useState(false);

  return (
    <>
      { AuthUtils.isAuth() && (<Redirect to="/" />) }
      { !AuthUtils.isAuth() && (
        <div className="c-app c-default-layout flex-row align-items-center">
          <CContainer>
            <CRow className="justify-content-center">
              <CCol xl="5" lg="6" md="8">
                <CCard className="p-4">
                  <CCardBody>
                    { setupComplete && <SetupNextSteps /> }
                    { !setupComplete && <SetupForm token={ token } setupComplete={ () => setSetupComplete(true) } /> }
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
          </CContainer>
        </div>
      ) }
    </>
  );
};

export default SetupPage;
